import styled from "styled-components";
import {
  IndividualUnitChartContainer,
  UnitChartGridContainer,
  UnitChartsNameContainer,
  UnitName,
} from "../UnitsAnalytics.styles";

export const FilterCountContainer = styled.div<{ isLast: boolean }>`
  display: flex;
  justify-content: center;
  align-items: ${props => (props.isLast ? "flex-start" : "center")};
  height: ${props => (props.isLast ? "140px" : "60px")};
  padding: ${props => (props.isLast ? "2rem 0" : "0.25rem 0")};

  > div {
    height: auto;
  }
`;

export const IndividualQuestionChartContainer = styled(IndividualUnitChartContainer as any)<{ isLast: boolean }>`
  height: ${props => (props.isLast ? "140px" : "60px")};
  padding: ${props => (props.isLast ? "1rem 0" : "0")};
`;

export const FilteredIndividualQuestionChartContainer = styled(IndividualQuestionChartContainer as any)<{
  isLast: boolean;
}>`
  padding: ${props => (props.isLast ? "0.25rem 0" : "0.5rem 0")};
`;

export const QuestionChartGridContainer = styled(UnitChartGridContainer as any)`
  grid-template-columns: 17% 10% 73%;
  grid-gap: 1rem;
  padding: 0 1rem;
`;

export const QuestionNameContainer = styled(UnitChartsNameContainer as any)<{ isLast: boolean }>`
  align-items: ${props => (props.isLast ? "flex-start" : "center")};
  margin: ${props => (props.isLast ? "2rem 0" : "1rem 0")};
`;

export const QuestionName = styled(UnitName as any)`
  margin: 0;
  font-weight: 500;
`;
